import Highlighter from 'react-highlight-words'

export default ({ color = '#ffe5b1', ...props }) => (
  <Highlighter {...props} highlightStyle={{ backgroundColor: color }} />
)
